import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractFieldComponent } from '../../abstract/abstract-field.component';
import { MatSelect } from '@angular/material';
import {FormFieldService} from '../../../services/form-field.service';

@Component({
  selector: 'app-material-multiselect',
  templateUrl: './material-multiselect.component.html',
  styleUrls: ['./material-multiselect.component.css']
})
export class MaterialMultiselectComponent extends AbstractFieldComponent implements OnInit {

  @ViewChild('selectField') selectField: MatSelect;
  @Input('selectLabel') selectLabel;

  trigger: boolean = true;
  contentText: string;

  constructor(public formFieldService: FormFieldService) {
    super(formFieldService);
  }

  comparator(o1: any, o2: any) {
    if (o1.id !== undefined && o2.id !== undefined) {
      return o1.id === o2.id;
    } else {
      return o1 === o2;
    }
  }

  ngOnInit(): void {
    this.setTriggerOption();
    this.getContentText();
    this.handleStatusChanges();
  }

  private setTriggerOption() {
    if (this.fieldConfig && this.fieldConfig.select && this.fieldConfig.select.trigger) {
      this.trigger = this.fieldConfig.select.trigger;
    }
  }

  private getContentText() {
    if (this.fieldConfig && this.fieldConfig.select && this.fieldConfig.select.contentTextType) {
      let contentTextType = this.fieldConfig.select.contentTextType;
      if (contentTextType) {
        if (contentTextType === SelectContentText.CUSTOM_TEXT && this.fieldConfig.select.contentText) {
          return this.fieldConfig.select.contentText;
        }
        if (contentTextType === SelectContentText.MORE_OPTIONS) {
          if (this.control.value) {
            return `Wybrano ${this.control.value.length} ${this.control.value.length > 4 ? 'opcji' : 'opcje'}`
          }
        }
        if (contentTextType === SelectContentText.CAPTION_TEXT) {
          return this.fieldConfig.caption;
        }
      }
    }
  }
}

export class SelectContentText {
  static CUSTOM_TEXT = 'CUSTOM_TEXT';
  static MORE_OPTIONS = 'MORE_OPTIONS';
  static CAPTION_TEXT = 'CAPTION_TEXT';
}
